import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  alignRight: {
    textAlign: "right"
  },
  icons: {
    marginTop: "5px",
    marginBottom: "5px",
    marginLeft: "40px"
  },
  titlePage: {
    color: "#fff",
    fontSize: "20px",
    textTransform: "uppercase",
    paddingTop: "10px"
  },
  titleSmallPage: {
    color: "#fff",
    fontSize: "14px",
    textTransform: "uppercase",
    paddingTop: "0px"
  },
  ui: {
    modal: {
      bottom: "inherit",
      right: "inherit"
    }
  },
  grid30: {
    width: "30%",
    backgroundColor: "#4E4E4E",
    padding: "15px",
    color: "#fff",
    boxShadow: "inset 0px 6px 15px -8px rgba(0,0,0,0.45)"
  },
  grid70: {
    width: "70%",
    backgroundColor: "#747474",
    padding: "9px",
    color: "#fff",
    display: "flex",
    boxShadow: "inset 0px 6px 15px -8px rgba(0,0,0,0.45)"
  },
  row: {
    paddingBottom: "15px"
  },
  btn: {
    fontSize: "14px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "400",
    padding: "9px 10px 8px",
    borderRadius: "0",
    width: "100%"
  },
  btnBlue: {
    color: "white",
    background: "#1e88e5",
    height: "38px",
    ":hover": {
      background: "#176ab3"
    }
  },
  select: {
    fontSize: "14px",
    borderRadius: "0px"
  },
  inputsearch: {
    backgroundColor: "transparent !important",
    boxShadow: "transparent !important",
    border: "transparent !important",
    width: "100%",
    fontSize: "14px",
    outline: "none"
  },
  pagination: {
    width: "auto",
  },
  divIcons: {
    width: "50%",
    textAlign: "right",
    paddingRight: "4px"
  },
  link: {
    marginLeft: "30px"
  },
  barWhite: {
    marginLeft: "30px",
    borderLeft: "2px solid #fff !important"
  },
  itenPaginationActive: {
    /*color: "#999",*/
    color: "#000",
    fontSize: "bolder",
    backgroundColor: "#FFF",
    padding: "4px 6px",
    marginRight: "10px",
    cursor: "pointer"
  },
  itenPagination: {
    backgroundColor: "rgba(255,255,255,.6)",
    padding: "4px 6px",
    marginRight: "10px",
    cursor: "pointer"
  },
  dotsPagination: {
    //backgroundColor: "rgba(255,255,255,.6)",
    padding: "4px 4px",
    marginRight: "10px",
    color: "whitesmoke"
  },
  arrow: {
    marginRight: "10px",
    cursor: "pointer",
    marginTop: "-4px"
  },
  paginationSelect: {
    backgroundColor: "#747474",
    border: "0px",
    outline: "none",
    minWidth: "50px"
  },
  divSelectPagination: {
    display: "inline-block",
    border: "1px solid #fff",
    marginLeft: "10px"
  },
  divPaginationArrow: {
    position: "absolute",
    top: "0px",
    backgroundColor: "#fff",
    paddingLeft: "5px",
    paddingRight: "5px",
    pointerEvents: "none"
  }
});

export default styles;
